import {Component, ViewEncapsulation} from '@angular/core';
import {AdvisorComponent} from '../advisor.component';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {EmbedService} from '../services/embed.service';
import {TrackingService} from '../services/tracking.service';
import {StromcheckBackendService} from './services/backend.service';
import {environment} from '../../environments/environment';

/**
 * The stromcheck component as wrapper for all steps of the application.
 * Attention: The mentioned scss file here will be replaced in angulaar.json and will not be included
 * in the deployment package. This is for development purpose only.
 */
@Component({
    selector: 'stromcheck-root',
    templateUrl: './stromcheck.component.html',
    styleUrls: environment.production === true ? [] : [
        '../../../../scss/stromcheck.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class StromcheckComponent extends AdvisorComponent {
  /**
   * constructor
   */
  constructor(public translate: TranslateService, protected router: Router, protected embedService: EmbedService,
              protected trackingService: TrackingService, protected backendService: StromcheckBackendService) {
    super(translate, router, embedService, trackingService);

    this.backendService.setAdvisor('stromcheck');
  }
}
